'use client'
import { useBackNavigation } from '@/hooks/useBackNavigation'
import Image from 'next/image'

export default function ReturnExchange() {
  const handleBack = useBackNavigation()
  
  return (
    <div>
      <h1 className="text-7xl font-bold text-chart-3 mb-8 hidden md:block">Cancellation & Return Policy:</h1>
      <div className="bg-white rounded-xl shadow-none md:shadow p0 md:p-6 mb-0 md:mb-8">
        <p className="mb-4">
          We go the extra mile to ensure that you receive precisely what you’ve ordered. Hence, once your order is being packed, you will be notified via WhatsApp. Additionally, you will receive a video showing your order being packed and prepared for shipment.
        </p>
        <p className="mb-4">
          Daily updates from our delivery partners, along with a tracking link for your orders, will be provided to you.
        </p>
        <b>Cancellation Policy:</b>
        <p className="mb-4">
          If you wish to cancel an order or item that has not yet been shipped, please contact our customer support team at <a href="mailto:support@curlified.com" className="text-primary underline">support@curlified.com</a>.
        </p>
        <p className="mb-4">
          Please note that if your order has already been shipped, we won’t be able to cancel it.
        </p>
        <b>Return Policy:</b>
        <p className="mb-4">
          If you’re not completely satisfied with your purchase, you have the option to return it for either an exchange or refund within 48 hours of the purchase date.
        </p>
        <b>Here are some key points to keep in mind when requesting a return.</b>
        <ul className="list-disc ml-6 mb-4">
          <li>Customers should retain the original packaging and send the returns in similar packaging unless the package is damaged before delivery.</li>
          <li>In case of a refund, only the paid amount will be refunded. Redeemed reward points cannot be re-credited. Shipping charges will not be refunded.</li>
        </ul>
        <b>Items which cannot be returned:</b>
        <ul className="list-disc ml-6 mb-4">
          <li>Products purchased during a sale cannot be returned.</li>
          <li>Used or altered products.</li>
          <li>Broken Seal</li>
          <li>Products that get damaged after delivery</li>
          <li>Requests initiated after 48 hours of order delivery</li>
          <li>Products purchased during a Sale</li>
          <li>Items within the Hair accessories and electrical tools category (such as heat caps, hairbrushes, bonnets, electrical styling tools, etc.)</li>
        </ul>
        <p className="mb-4">
          Don’t forget to include an unboxing video starting from opening up the waterproof wrap, and no edits allowed. We will not be able to help you if the unboxing video does not follow our mentioned instruction.
        </p>
        <p className="mb-4">
          To initiate a return, please contact our customer service team with your order ID to obtain a return. <b>Please note that you will be responsible for the cost of return shipping</b>, unless the item is being returned due to a defect or error on our part.
        </p>
        <p className="mb-4">
          Once we receive your return, we will inspect it to ensure it meets our return policy requirements. If everything checks out, we will issue a refund to the original payment method within 7 to 10 business days.
        </p>
        <p className="mb-4">
          It may take additional time for the refund to appear on your credit card statement, depending on your bank’s processing times.
        </p>
        <p className="mb-4">
          Please note that you will be responsible for the cost of return shipping, and we will cover the cost of shipping the replacement item to you.
        </p>
        <b>Damaged or Defective items:</b>
        <p className="mb-4">
          We kindly ask all our customers to record an unboxing video starting from the opening of the waterproof wrap, ensuring no edits are made. Please note that if the unboxing video does not adhere to our provided instructions, we may not be able to provide assistance.
        </p>
        <p className="mb-4">
          This will allow us to quickly address any potential issues as we may need images and videos for our records.
        </p>
        <p className="mb-4">
          Should you receive a damaged or defective item, please reach out to us at <a href="mailto:support@curlified.com" className="text-primary underline">support@curlified.com</a>. We will collaborate with you to facilitate a replacement or refund, according to your preference. If you have any inquiries or uncertainties regarding our cancellation and returns policy,
        </p>
        <p>
          Please feel free to get in touch with our customer service team at <a href="mailto:support@curlified.com" className="text-primary underline">support@curlified.com</a>. We’re dedicated to assisting you at all times.
        </p>
      </div>
    </div>
  )
}